import { FC, useCallback } from "react";
import { Divider, Tooltip } from "@mui/material";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

interface AttachmentItemProps {
  showDivider: boolean;
  id: string;
  onClick?(id: string): void;
}

export const AttachmentItem: FC<AttachmentItemProps> = ({
  id,
  onClick,
  showDivider,
}) => {
  const clickHandler = useCallback(() => {
    onClick?.(id);
  }, [onClick, id]);

  return (
    <Tooltip arrow title="View Attachment" placement="top">
      <span>
        <TypographyWithTooltip
          color="primary"
          variant="body2"
          title={id}
          px={2}
          pb={1}
          pt={0.5}
          onClick={clickHandler}
          sx={{ flex: 1, cursor: "pointer", minWidth: 50 }}
        />
        {showDivider && <Divider />}
      </span>
    </Tooltip>
  );
};
